import React from "react";
import { useT } from "../i18n/LanguageContext";

const Sidebar = ({ onSelect, handleLogout, student, selected }) => {
  const { t } = useT();
  const menuItems = [
    { key: "dashboard", label: t("studentNav.dashboard") },
    { key: "profile", label: t("studentNav.profile") },
    { key: "admission-form", label: t("studentNav.admissionForm") },
    { key: "subject-selection", label: t("studentNav.subjectSelection") },
    { key: "documents", label: t("studentNav.documentUpload") },
    { key: "payment", label: t("studentNav.payment") },
    { key: "certificate", label: t("studentNav.certificate") },
  ];

  return (
    <div className="h-full overflow-y-auto" style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}>
      <div className="w-full md:w-64 bg-gray-900 text-white h-full p-4 flex flex-col">
        <h2 className="text-xl font-semibold mb-4 border-b border-gray-700 pb-2">
          {t("studentNav.studentPortal")}
        </h2>
        <p className="text-sm text-gray-300 mb-6">
          {t("adminNav.welcome")}, <span className="font-semibold">{student.name}</span>
        </p>

        <nav className="flex-1 space-y-0.5">
          {menuItems.map((item) => (
            <button
              key={item.key}
              className={`w-full text-left px-2 py-2 rounded text-sm ${
                selected === item.key ? "bg-gray-700" : "hover:bg-gray-700"
              }`}
              onClick={() => onSelect(item.key)}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="pt-3 mt-3 border-t border-gray-700">
          <button
            className="w-full text-left text-red-400 px-2 py-2 hover:bg-red-700 hover:text-white rounded text-sm"
            onClick={handleLogout}
          >
            {t("common.logout")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
